import React from 'react';
import { Select } from '@atoms';

export interface ResourceFilterProps {
  resources: string[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const ResourceFilter: React.FC<ResourceFilterProps> = ({
  resources,
  value,
  onChange,
  placeholder = "All Resources",
  className = ""
}) => {
  const options = [
    { label: placeholder, value: "" },
    ...resources.map(resource => ({ label: resource, value: resource }))
  ];

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      className={className}
    />
  );
};
